module.exports = __webpack_public_path__ + "static/media/sun travels.2225aeb5.png";